import React from 'react';
import { FadeIn } from './FadeIn';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const problems = [
  { icon: FiIcons.FiTrendingDown, title: "Volatilität", desc: "Das ständige Auf und Ab der Kurse raubt Ihnen den Schlaf. Hoffen auf Kursgewinne ist keine verlässliche Strategie." },
  { icon: FiIcons.FiPieChart, title: "Inflation", desc: "Ihr Geld verliert jeden Tag an Wert. Wenn Ihr Kapital nicht arbeitet, schmilzt Ihre Kaufkraft unaufhaltsam dahin." },
  { icon: FiIcons.FiDollarSign, title: "Kein Cashflow", desc: "Buchgewinne auf dem Papier zahlen keine Rechnungen. Ohne echtes Einkommen bleiben Sie abhängig von den Launen des Marktes." },
];

export const Problem = () => {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <FadeIn className="text-center max-w-3xl mx-auto mb-12">
          <h2 className="font-serif text-3xl md:text-5xl text-navy font-bold mb-5">
            Warum "klassisches Investieren" oft scheitert
          </h2>
          <div className="w-20 h-1 bg-gold mx-auto mb-5"></div>
          <p className="font-sans text-gray-600 text-base md:text-lg">
            Die meisten Anleger machen denselben Fehler: Sie hoffen auf Kursgewinne, die morgen wieder verschwunden sein können.
          </p>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {problems.map((item, index) => (
            <FadeIn key={index} delay={index * 0.15} direction="up">
              <div className="bg-gray-50 p-7 rounded-xl border border-gray-100 shadow-luxury hover:shadow-2xl transition-shadow duration-300 h-full flex flex-col items-center text-center">
                <div className="w-14 h-14 bg-navy/5 rounded-full flex items-center justify-center mb-5">
                  <SafeIcon icon={item.icon} className="text-2xl text-navy" />
                </div>
                <h3 className="font-serif text-xl text-navy font-bold mb-3">{item.title}</h3>
                <p className="font-sans text-gray-600 text-sm leading-relaxed">{item.desc}</p>
              </div>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  );
};